import { getIcon } from "@/components/Icons";
import { arrowFocus } from "./keys";
import type { Area } from "./model";

export function Rail({ areas, activeId, logoSrc, accent, onPick }: {
  areas: Area[];
  activeId: string | null;
  logoSrc: string;
  accent: string;
  onPick: (area: Area) => void;
}) {
  const button = (a: Area) => {
    const I = getIcon(a.icon);
    const active = a.id === activeId;
    return (
      <button
        key={a.id}
        type="button"
        className={"rail-btn" + (active ? " active" : "")}
        aria-label={a.label}
        aria-current={active ? "true" : undefined}
        title={a.label}
        onClick={() => onPick(a)}
      >
        <I size={20} />
        <span className="rail-label" aria-hidden="true">{a.label}</span>
      </button>
    );
  };
  return (
    <nav className="rail" aria-label="Areas" data-tour="modules" onKeyDown={(e) => arrowFocus(e, ".rail-btn")}>
      <span className="brand-mark" style={{ background: accent }}>
        <img src={logoSrc} alt="" style={{ width: 20, height: 20, objectFit: "contain" }} />
      </span>
      {areas.filter((a) => !a.pinBottom).map(button)}
      <div className="rail-spacer" />
      {areas.filter((a) => a.pinBottom).map(button)}
    </nav>
  );
}
